export const mediaQuery = {
  FORM_INPUT_TO_FULL_INPUT: "@media (max-width: 1350px)",
};
